import styled from '@emotion/styled';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  overflow: auto;
`;

export const Header = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #f1f3f5;
  padding: 20px 24px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Content = styled.div`
  background: #ffffff;
  padding: 24px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
`;
